/**
 * @generated SignedSource<<637e5e0f4363eff38eef07c9273e05a3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type logsTable_logEdges$data = ReadonlyArray<{
  readonly node: {
    readonly actionTimestamp: AGG$DateTime;
    readonly notificationActionType: string | null | undefined;
    readonly notificationDetails: {
      readonly errorKey: string | null | undefined;
      readonly mailboxMessage: string | null | undefined;
    } | null | undefined;
    readonly recipient: {
      readonly email?: string | null | undefined;
      readonly name?: string;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "logsTable_logEdges";
}>;
export type logsTable_logEdges$key = ReadonlyArray<{
  readonly " $data"?: logsTable_logEdges$data;
  readonly " $fragmentSpreads": FragmentRefs<"logsTable_logEdges">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "logsTable_logEdges",
  "selections": [
    {
      "concreteType": "AquaOutgoingEmailLogItem",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "notificationActionType"
        },
        {
          "kind": "ScalarField",
          "name": "actionTimestamp"
        },
        {
          "concreteType": "AquaNotificationDetails",
          "kind": "LinkedField",
          "name": "notificationDetails",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "errorKey"
            },
            {
              "kind": "ScalarField",
              "name": "mailboxMessage"
            }
          ]
        },
        {
          "kind": "LinkedField",
          "name": "recipient",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "email"
                }
              ],
              "type": "AtlassianAccountUser"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "name"
                }
              ],
              "type": "CustomerUser"
            }
          ]
        }
      ]
    }
  ],
  "type": "AquaOutgoingEmailLogItemEdge"
};

(node as any).hash = "48e23bd9eac76036619daebc8ad9509f";

export default node;
